/**
 * The negative ("down") colour defaults. The dark default is 5.1:1 on the dark panels (#16181b) but only
 * 3.5:1 on white, so light mode draws with a darker red unless the reader chose their own colour.
 * Kept free of other imports so the unit runner can load it (ortex/ortex-gui#1377).
 */

/** rgb(234,87,99) = #ea5763: 5.1:1 on #16181b, 4.7:1 on #1d2024. The old default #e24250 was 4.3:1. */
export const NEGATIVE_DEFAULT = "rgb(234,87,99)";

/** rgb(201,60,72) = #c93c48: 5.0:1 on white, 4.7:1 on #f7f8f9. */
export const NEGATIVE_LIGHT_DEFAULT = "rgb(201,60,72)";

/**
 * The colour the UI draws with: the reader's own value in either theme, else the theme's default. An
 * old saved default counts as a default, so accounts that persisted #e24250 get the fix too.
 */
export const resolveNegativeColor = (theme: "dark" | "light", setting: string, isManual: boolean): string => (isManual ? setting : theme === "light" ? NEGATIVE_LIGHT_DEFAULT : NEGATIVE_DEFAULT);
